function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 29H21",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.83748 20.875C8.64698 19.9493 7.68276 18.7648 7.01789 17.4112C6.35301 16.0577 6.00492 14.5705 5.99998 13.0625C5.97498 7.6375 10.3375 3.125 15.7625 3C17.8621 2.95023 19.924 3.56276 21.6559 4.75071C23.3878 5.93866 24.7018 7.64174 25.4114 9.6184C26.121 11.5951 26.1902 13.745 25.6093 15.7632C25.0284 17.7814 23.8268 19.5655 22.175 20.8625C21.8101 21.1446 21.5145 21.5063 21.3109 21.9201C21.1072 22.3339 21.0009 22.7888 21 23.25V24C21 24.2652 20.8946 24.5196 20.7071 24.7071C20.5196 24.8946 20.2652 25 20 25H12C11.7348 25 11.4804 24.8946 11.2929 24.7071C11.1053 24.5196 11 24.2652 11 24V23.25C10.9969 22.7923 10.8907 22.3411 10.6895 21.93C10.4883 21.5188 10.1971 21.1583 9.83748 20.875V20.875Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0125 7.1C18.2347 7.30719 19.3624 7.88863 20.2401 8.76408C21.1178 9.63952 21.7021 10.7658 21.9125 11.9875",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgExample = function SvgExample(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExample, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Example.6396cd37.svg";
export { ForwardRef as ReactComponent };